import { InputNumber } from "../../../../../../../components/InputNumber/InputNumber.tsx";
import { SETTINGS_ITEM_WIDTH } from "../../constants.ts";

export const CornerRadiusInputNumber = ({
  radius,
  onRadiusChange,
}: {
  radius: number;
  onRadiusChange: (radius: number) => void;
}) => {
  const maxValue = 100;

  const onIconDrag = (deltaX: number, pixelRange: number) => {
    const radiusDelta = (deltaX / pixelRange) * maxValue;
    const clampedRadiusDelta = Math.max(
      0,
      Math.min(maxValue, radius + radiusDelta),
    );
    onRadiusChange(Math.round(clampedRadiusDelta));
  };

  return (
    <InputNumber
      value={radius}
      min={0}
      max={100}
      className={SETTINGS_ITEM_WIDTH}
      iconName="SquareRoundCorner"
      onChange={onRadiusChange}
      onIconDrag={(deltaX) => onIconDrag(deltaX, 200)}
    />
  );
};
